import React, { FC } from 'react';

import { useBoolean } from '../../../../../common/Hooks/useBoolean.hook';
import { ArrowDown } from '../../../../../../components/ArrowDown/ArrowDown';
import { ArrowUp } from '../../../../../../components/ArrowUp/ArrowUp';
import { StyledLeaderboardsDrawer } from './LeaderboardsDrawer.styles';
import EventLeaderboards from '../../../../EventLeaderboards/EventLeaderboards';

type TProps = Record<'eventId' | 'holeIndex' | 'roundId', number>;

export const LeaderboardsDrawer: FC<TProps> = props => {
  const { eventId, roundId, holeIndex } = props;

  const [open, , toggleDrawer] = useBoolean(false);

  return (
    <StyledLeaderboardsDrawer
      anchor="bottom"
      open={open}
      onClose={toggleDrawer}
      ModalProps={{
        keepMounted: true
      }}
    >
      <div onClick={toggleDrawer} className="drawer-title">
        <span>LEADERBOARDS</span>

        {open ? <ArrowUp onClick={toggleDrawer} /> : <ArrowDown onClick={toggleDrawer} />}
      </div>

      <div className="drawer-content">
        <EventLeaderboards eventId={eventId} roundId={roundId} holeIndex={holeIndex} />
      </div>
    </StyledLeaderboardsDrawer>
  );
};
